export const palikaFeatures = {
    'bansgadhimun': [],
    'siyarimun': [
        'NEPAL_LOGO_WATERMARK',
        'FONT_KALIMATI'
    ],
    'mathagadhimun': [
        'EMAIL_PASSWORD'
    ]
}



export const hasFeature = (palika, feature) => {
    return (palikaFeatures[palika] ?? []).includes(feature);
}
